@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.autosplit-modal-body {
  min-width: 460px;
}

.loader {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  padding: 80px 0;
}

.bulk-apply-message {
  padding: 8px 16px;
  font-size: 14px;
  color: @product-page--modal--text-color;
  background: @product-page--modal-message--background-color;
  line-height: 2;
}

.autosplit-options {
  margin: 0 16px 16px;
}
